import { render, staticRenderFns } from "./identity-card-menu-item-component.vue?vue&type=template&id=49d93870"
import script from "./identity-card-menu-item-component.ts?vue&type=script&lang=ts&external"
export * from "./identity-card-menu-item-component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports